import React, { Children } from 'react';
import { motion } from 'framer-motion';
const items = ['Tenés perro, gato o ambos y querés mejorar su alimentación de verdad.', 'Estás cansado de gastar en veterinario sin resultados claros ni duraderos.', 'Querés hacer la transición a comida natural sin cometer errores costosos.', 'No tenés conocimientos técnicos pero querés hacer las cosas bien.', 'Buscás recetas simples con ingredientes accesibles en cualquier mercado.'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function WhoItsFor() {
  return <section className="bg-white py-24 px-6" data-id="element-89">
      <div className="max-w-3xl mx-auto" data-id="element-90">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-[2rem] md:text-[2.4rem] text-brand-darkgreen text-center mb-16 leading-tight" data-id="element-91">
          Esta guía es para vos si...
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="flex flex-col gap-4" data-id="element-92">
          {items.map((text, index) => <motion.div key={index} variants={itemVariants} className="bg-brand-cream rounded-full py-5 px-8 shadow-[0_4px_15px_rgba(0,0,0,0.03)] flex items-center gap-4" data-id="element-93">
              <span className="text-2xl shrink-0" data-id="element-94">🐾</span>
              <p className="text-brand-text font-medium leading-snug" data-id="element-95">{text}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}